var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('check-room-inputs',{attrs:{"items":_vm.rooms,"value":_vm.value},on:{"input":_vm.input,"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }